"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");
var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");
var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};
var __accessCheck = function __accessCheck(obj, member, msg) {
  if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var __privateGet = function __privateGet(obj, member, getter) {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = function __privateAdd(obj, member, value) {
  if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = function __privateSet(obj, member, value, setter) {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var isomorphicClerk_exports = {};
__export(isomorphicClerk_exports, {
  default: function _default() {
    return IsomorphicClerk;
  }
});
module.exports = __toCommonJS(isomorphicClerk_exports);
var import_shared = require("@clerk/shared");
var import_errors = require("./errors");
var import_utils = require("./utils");
var _loaded, _domain, _proxyUrl, _instance;
var _IsomorphicClerk = /*#__PURE__*/function () {
  function _IsomorphicClerk(options) {
    var _this = this;
    _classCallCheck(this, _IsomorphicClerk);
    this.clerkjs = null;
    this.preopenSignIn = null;
    this.preopenSignUp = null;
    this.preopenUserProfile = null;
    this.preopenOrganizationProfile = null;
    this.preopenCreateOrganization = null;
    this.premountSignInNodes = /* @__PURE__ */new Map();
    this.premountSignUpNodes = /* @__PURE__ */new Map();
    this.premountUserProfileNodes = /* @__PURE__ */new Map();
    this.premountUserButtonNodes = /* @__PURE__ */new Map();
    this.premountOrganizationProfileNodes = /* @__PURE__ */new Map();
    this.premountCreateOrganizationNodes = /* @__PURE__ */new Map();
    this.premountOrganizationSwitcherNodes = /* @__PURE__ */new Map();
    this.premountMethodCalls = /* @__PURE__ */new Map();
    this.loadedListeners = [];
    __privateAdd(this, _loaded, false);
    __privateAdd(this, _domain, void 0);
    __privateAdd(this, _proxyUrl, void 0);
    this.addOnLoaded = function (cb) {
      _this.loadedListeners.push(cb);
    };
    this.emitLoaded = function () {
      _this.loadedListeners.forEach(function (cb) {
        return cb();
      });
      _this.loadedListeners = [];
    };
    this.hydrateClerkJS = function (clerkjs) {
      if (!clerkjs) {
        throw new Error("Failed to hydrate latest Clerk JS");
      }
      _this.clerkjs = clerkjs;
      _this.premountMethodCalls.forEach(function (cb) {
        return cb();
      });
      if (_this.preopenSignIn !== null) {
        clerkjs.openSignIn(_this.preopenSignIn);
      }
      if (_this.preopenSignUp !== null) {
        clerkjs.openSignUp(_this.preopenSignUp);
      }
      if (_this.preopenUserProfile !== null) {
        clerkjs.openUserProfile(_this.preopenUserProfile);
      }
      if (_this.preopenOrganizationProfile !== null) {
        clerkjs.openOrganizationProfile(_this.preopenOrganizationProfile);
      }
      if (_this.preopenCreateOrganization !== null) {
        clerkjs.openCreateOrganization(_this.preopenCreateOrganization);
      }
      _this.premountSignInNodes.forEach(function (props, node) {
        clerkjs.mountSignIn(node, props);
      });
      _this.premountSignUpNodes.forEach(function (props, node) {
        clerkjs.mountSignUp(node, props);
      });
      _this.premountUserProfileNodes.forEach(function (props, node) {
        clerkjs.mountUserProfile(node, props);
      });
      _this.premountUserButtonNodes.forEach(function (props, node) {
        clerkjs.mountUserButton(node, props);
      });
      __privateSet(_this, _loaded, true);
      _this.emitLoaded();
      return _this.clerkjs;
    };
    this.__unstable__updateProps = function (props) {
      if (_this.clerkjs && "__unstable__updateProps" in _this.clerkjs) {
        _this.clerkjs.__unstable__updateProps(props);
      } else {
        return void 0;
      }
    };
    /**
     * `setActive` can be used to set the active session and/or organization.
     * It will eventually replace `setSession`.
     *
     * @experimental
     */
    this.setActive = function (_ref) {
      var session = _ref.session,
        organization = _ref.organization,
        beforeEmit = _ref.beforeEmit;
      if (_this.clerkjs) {
        return _this.clerkjs.setActive({
          session: session,
          organization: organization,
          beforeEmit: beforeEmit
        });
      } else {
        return Promise.reject();
      }
    };
    this.setSession = function (session, beforeEmit) {
      return _this.setActive({
        session: session,
        beforeEmit: beforeEmit
      });
    };
    this.openSignIn = function (props) {
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        _this.clerkjs.openSignIn(props);
      } else {
        _this.preopenSignIn = props;
      }
    };
    this.closeSignIn = function () {
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        _this.clerkjs.closeSignIn();
      } else {
        _this.preopenSignIn = null;
      }
    };
    this.openUserProfile = function (props) {
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        _this.clerkjs.openUserProfile(props);
      } else {
        _this.preopenUserProfile = props;
      }
    };
    this.closeUserProfile = function () {
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        _this.clerkjs.closeUserProfile();
      } else {
        _this.preopenUserProfile = null;
      }
    };
    this.openOrganizationProfile = function (props) {
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        _this.clerkjs.openOrganizationProfile(props);
      } else {
        _this.preopenOrganizationProfile = props;
      }
    };
    this.closeOrganizationProfile = function () {
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        _this.clerkjs.closeOrganizationProfile();
      } else {
        _this.preopenOrganizationProfile = null;
      }
    };
    this.openCreateOrganization = function (props) {
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        _this.clerkjs.openCreateOrganization(props);
      } else {
        _this.preopenCreateOrganization = props;
      }
    };
    this.closeCreateOrganization = function () {
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        _this.clerkjs.closeCreateOrganization();
      } else {
        _this.preopenCreateOrganization = null;
      }
    };
    this.openSignUp = function (props) {
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        _this.clerkjs.openSignUp(props);
      } else {
        _this.preopenSignUp = props;
      }
    };
    this.closeSignUp = function () {
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        _this.clerkjs.closeSignUp();
      } else {
        _this.preopenSignUp = null;
      }
    };
    this.mountSignIn = function (node, props) {
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        _this.clerkjs.mountSignIn(node, props);
      } else {
        _this.premountSignInNodes.set(node, props);
      }
    };
    this.unmountSignIn = function (node) {
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        _this.clerkjs.unmountSignIn(node);
      } else {
        _this.premountSignInNodes.delete(node);
      }
    };
    this.mountSignUp = function (node, props) {
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        _this.clerkjs.mountSignUp(node, props);
      } else {
        _this.premountSignUpNodes.set(node, props);
      }
    };
    this.unmountSignUp = function (node) {
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        _this.clerkjs.unmountSignUp(node);
      } else {
        _this.premountSignUpNodes.delete(node);
      }
    };
    this.mountUserProfile = function (node, props) {
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        _this.clerkjs.mountUserProfile(node, props);
      } else {
        _this.premountUserProfileNodes.set(node, props);
      }
    };
    this.unmountUserProfile = function (node) {
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        _this.clerkjs.unmountUserProfile(node);
      } else {
        _this.premountUserProfileNodes.delete(node);
      }
    };
    this.mountOrganizationProfile = function (node, props) {
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        _this.clerkjs.mountOrganizationProfile(node, props);
      } else {
        _this.premountOrganizationProfileNodes.set(node, props);
      }
    };
    this.unmountOrganizationProfile = function (node) {
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        _this.clerkjs.unmountOrganizationProfile(node);
      } else {
        _this.premountOrganizationProfileNodes.delete(node);
      }
    };
    this.mountCreateOrganization = function (node, props) {
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        _this.clerkjs.mountCreateOrganization(node, props);
      } else {
        _this.premountCreateOrganizationNodes.set(node, props);
      }
    };
    this.unmountCreateOrganization = function (node) {
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        _this.clerkjs.unmountCreateOrganization(node);
      } else {
        _this.premountCreateOrganizationNodes.delete(node);
      }
    };
    this.mountOrganizationSwitcher = function (node, props) {
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        _this.clerkjs.mountOrganizationSwitcher(node, props);
      } else {
        _this.premountOrganizationSwitcherNodes.set(node, props);
      }
    };
    this.unmountOrganizationSwitcher = function (node) {
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        _this.clerkjs.unmountOrganizationSwitcher(node);
      } else {
        _this.premountOrganizationSwitcherNodes.delete(node);
      }
    };
    this.mountUserButton = function (node, userButtonProps) {
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        _this.clerkjs.mountUserButton(node, userButtonProps);
      } else {
        _this.premountUserButtonNodes.set(node, userButtonProps);
      }
    };
    this.unmountUserButton = function (node) {
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        _this.clerkjs.unmountUserButton(node);
      } else {
        _this.premountUserButtonNodes.delete(node);
      }
    };
    this.addListener = function (listener) {
      var callback = function callback() {
        var _this$clerkjs;
        return (_this$clerkjs = _this.clerkjs) === null || _this$clerkjs === void 0 ? void 0 : _this$clerkjs.addListener(listener);
      };
      if (_this.clerkjs) {
        return callback();
      } else {
        _this.premountMethodCalls.set("addListener", callback);
        return function () {
          return _this.premountMethodCalls.delete("addListener");
        };
      }
    };
    this.navigate = function (to) {
      var callback = function callback() {
        var _this$clerkjs2;
        return (_this$clerkjs2 = _this.clerkjs) === null || _this$clerkjs2 === void 0 ? void 0 : _this$clerkjs2.navigate(to);
      };
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        void callback();
      } else {
        _this.premountMethodCalls.set("navigate", callback);
      }
    };
    this.redirectWithAuth = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var callback = function callback() {
        var _this$clerkjs3;
        return (_this$clerkjs3 = _this.clerkjs) === null || _this$clerkjs3 === void 0 ? void 0 : _this$clerkjs3.redirectWithAuth.apply(_this$clerkjs3, args);
      };
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        void callback();
      } else {
        _this.premountMethodCalls.set("redirectWithAuth", callback);
      }
    };
    this.redirectToSignIn = function (opts) {
      var callback = function callback() {
        var _this$clerkjs4;
        return (_this$clerkjs4 = _this.clerkjs) === null || _this$clerkjs4 === void 0 ? void 0 : _this$clerkjs4.redirectToSignIn(opts);
      };
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        void callback();
      } else {
        _this.premountMethodCalls.set("redirectToSignIn", callback);
      }
    };
    this.redirectToSignUp = function (opts) {
      var callback = function callback() {
        var _this$clerkjs5;
        return (_this$clerkjs5 = _this.clerkjs) === null || _this$clerkjs5 === void 0 ? void 0 : _this$clerkjs5.redirectToSignUp(opts);
      };
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        void callback();
      } else {
        _this.premountMethodCalls.set("redirectToSignUp", callback);
      }
    };
    this.redirectToUserProfile = function () {
      var callback = function callback() {
        var _this$clerkjs6;
        return (_this$clerkjs6 = _this.clerkjs) === null || _this$clerkjs6 === void 0 ? void 0 : _this$clerkjs6.redirectToUserProfile();
      };
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        callback();
      } else {
        _this.premountMethodCalls.set("redirectToUserProfile", callback);
      }
    };
    this.redirectToHome = function () {
      var callback = function callback() {
        var _this$clerkjs7;
        return (_this$clerkjs7 = _this.clerkjs) === null || _this$clerkjs7 === void 0 ? void 0 : _this$clerkjs7.redirectToHome();
      };
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        callback();
      } else {
        _this.premountMethodCalls.set("redirectToHome", callback);
      }
    };
    this.redirectToOrganizationProfile = function () {
      var callback = function callback() {
        var _this$clerkjs8;
        return (_this$clerkjs8 = _this.clerkjs) === null || _this$clerkjs8 === void 0 ? void 0 : _this$clerkjs8.redirectToOrganizationProfile();
      };
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        callback();
      } else {
        _this.premountMethodCalls.set("redirectToOrganizationProfile", callback);
      }
    };
    this.redirectToCreateOrganization = function () {
      var callback = function callback() {
        var _this$clerkjs9;
        return (_this$clerkjs9 = _this.clerkjs) === null || _this$clerkjs9 === void 0 ? void 0 : _this$clerkjs9.redirectToCreateOrganization();
      };
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        callback();
      } else {
        _this.premountMethodCalls.set("redirectToCreateOrganization", callback);
      }
    };
    this.handleRedirectCallback = function (params) {
      var callback = function callback() {
        var _this$clerkjs10;
        return (_this$clerkjs10 = _this.clerkjs) === null || _this$clerkjs10 === void 0 ? void 0 : _this$clerkjs10.handleRedirectCallback(params);
      };
      if (_this.clerkjs && __privateGet(_this, _loaded)) {
        var _callback;
        void ((_callback = callback()) === null || _callback === void 0 ? void 0 : _callback.catch(function () {}));
      } else {
        _this.premountMethodCalls.set("handleRedirectCallback", callback);
      }
    };
    this.handleMagicLinkVerification = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        var callback;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                callback = function callback() {
                  var _this$clerkjs11;
                  return (_this$clerkjs11 = _this.clerkjs) === null || _this$clerkjs11 === void 0 ? void 0 : _this$clerkjs11.handleMagicLinkVerification(params);
                };
                if (!(_this.clerkjs && __privateGet(_this, _loaded))) {
                  _context.next = 5;
                  break;
                }
                return _context.abrupt("return", callback());
              case 5:
                _this.premountMethodCalls.set("handleMagicLinkVerification", callback);
              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    this.authenticateWithMetamask = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
        var callback;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                callback = function callback() {
                  var _this$clerkjs12;
                  return (_this$clerkjs12 = _this.clerkjs) === null || _this$clerkjs12 === void 0 ? void 0 : _this$clerkjs12.authenticateWithMetamask(params);
                };
                if (!(_this.clerkjs && __privateGet(_this, _loaded))) {
                  _context2.next = 5;
                  break;
                }
                return _context2.abrupt("return", callback());
              case 5:
                _this.premountMethodCalls.set("authenticateWithMetamask", callback);
              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }();
    this.createOrganization = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
        var callback;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                callback = function callback() {
                  var _this$clerkjs13;
                  return (_this$clerkjs13 = _this.clerkjs) === null || _this$clerkjs13 === void 0 ? void 0 : _this$clerkjs13.createOrganization(params);
                };
                if (!(_this.clerkjs && __privateGet(_this, _loaded))) {
                  _context3.next = 5;
                  break;
                }
                return _context3.abrupt("return", callback());
              case 5:
                _this.premountMethodCalls.set("createOrganization", callback);
              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    }();
    this.getOrganizationMemberships = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var callback;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              callback = function callback() {
                var _this$clerkjs14;
                return (_this$clerkjs14 = _this.clerkjs) === null || _this$clerkjs14 === void 0 ? void 0 : _this$clerkjs14.getOrganizationMemberships();
              };
              if (!(_this.clerkjs && __privateGet(_this, _loaded))) {
                _context4.next = 5;
                break;
              }
              return _context4.abrupt("return", callback());
            case 5:
              _this.premountMethodCalls.set("getOrganizationMemberships", callback);
            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    this.getOrganization = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(organizationId) {
        var callback;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                callback = function callback() {
                  var _this$clerkjs15;
                  return (_this$clerkjs15 = _this.clerkjs) === null || _this$clerkjs15 === void 0 ? void 0 : _this$clerkjs15.getOrganization(organizationId);
                };
                if (!(_this.clerkjs && __privateGet(_this, _loaded))) {
                  _context5.next = 5;
                  break;
                }
                return _context5.abrupt("return", callback());
              case 5:
                _this.premountMethodCalls.set("getOrganization", callback);
              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
      return function (_x4) {
        return _ref6.apply(this, arguments);
      };
    }();
    this.signOut = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(signOutCallbackOrOptions, options) {
        var callback;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                callback = function callback() {
                  var _this$clerkjs16;
                  return (_this$clerkjs16 = _this.clerkjs) === null || _this$clerkjs16 === void 0 ? void 0 : _this$clerkjs16.signOut(signOutCallbackOrOptions, options);
                };
                if (!(_this.clerkjs && __privateGet(_this, _loaded))) {
                  _context6.next = 5;
                  break;
                }
                return _context6.abrupt("return", callback());
              case 5:
                _this.premountMethodCalls.set("signOut", callback);
              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
      return function (_x5, _x6) {
        return _ref7.apply(this, arguments);
      };
    }();
    var _ref8 = options || {},
      _ref8$Clerk = _ref8.Clerk,
      Clerk = _ref8$Clerk === void 0 ? null : _ref8$Clerk,
      frontendApi = _ref8.frontendApi,
      publishableKey = _ref8.publishableKey;
    this.frontendApi = frontendApi;
    this.publishableKey = publishableKey;
    __privateSet(this, _proxyUrl, options === null || options === void 0 ? void 0 : options.proxyUrl);
    __privateSet(this, _domain, options === null || options === void 0 ? void 0 : options.domain);
    this.options = options;
    this.Clerk = Clerk;
    this.mode = (0, import_shared.inClientSide)() ? "browser" : "server";
    void this.loadClerkJS();
  }
  _createClass(_IsomorphicClerk, [{
    key: "loaded",
    get: function get() {
      return __privateGet(this, _loaded);
    }
  }, {
    key: "domain",
    get: function get() {
      if (typeof window !== "undefined" && window.location) {
        return (0, import_shared.handleValueOrFn)(__privateGet(this, _domain), new URL(window.location.href), "");
      }
      if (typeof __privateGet(this, _domain) === "function") {
        throw new Error(import_errors.unsupportedNonBrowserDomainOrProxyUrlFunction);
      }
      return __privateGet(this, _domain) || "";
    }
  }, {
    key: "proxyUrl",
    get: function get() {
      if (typeof window !== "undefined" && window.location) {
        return (0, import_shared.handleValueOrFn)(__privateGet(this, _proxyUrl), new URL(window.location.href), "");
      }
      if (typeof __privateGet(this, _proxyUrl) === "function") {
        throw new Error(import_errors.unsupportedNonBrowserDomainOrProxyUrlFunction);
      }
      return __privateGet(this, _proxyUrl) || "";
    }
  }, {
    key: "loadClerkJS",
    value: function () {
      var _loadClerkJS = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _global$Clerk, _global$Clerk2, c, error;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(this.mode !== "browser" || __privateGet(this, _loaded))) {
                  _context7.next = 2;
                  break;
                }
                return _context7.abrupt("return");
              case 2:
                if (typeof window !== "undefined") {
                  window.__clerk_frontend_api = this.frontendApi;
                  window.__clerk_publishable_key = this.publishableKey;
                  window.__clerk_proxy_url = this.proxyUrl;
                  window.__clerk_domain = this.domain;
                }
                _context7.prev = 3;
                if (!this.Clerk) {
                  _context7.next = 18;
                  break;
                }
                if (!(0, import_utils.isConstructor)(this.Clerk)) {
                  _context7.next = 11;
                  break;
                }
                c = new this.Clerk(this.publishableKey || this.frontendApi || "", {
                  proxyUrl: this.proxyUrl,
                  domain: this.domain
                });
                _context7.next = 9;
                return c.load(this.options);
              case 9:
                _context7.next = 15;
                break;
              case 11:
                c = this.Clerk;
                if (c.isReady()) {
                  _context7.next = 15;
                  break;
                }
                _context7.next = 15;
                return c.load(this.options);
              case 15:
                global.Clerk = c;
                _context7.next = 25;
                break;
              case 18:
                if (global.Clerk) {
                  _context7.next = 21;
                  break;
                }
                _context7.next = 21;
                return (0, import_utils.loadClerkJsScript)(_objectSpread(_objectSpread({}, this.options), {}, {
                  frontendApi: this.frontendApi,
                  publishableKey: this.publishableKey,
                  proxyUrl: this.proxyUrl,
                  domain: this.domain
                }));
              case 21:
                if (global.Clerk) {
                  _context7.next = 23;
                  break;
                }
                throw new Error("Failed to download latest ClerkJS. Contact support@clerk.com.");
              case 23:
                _context7.next = 25;
                return global.Clerk.load(this.options);
              case 25:
                if (!((_global$Clerk = global.Clerk) !== null && _global$Clerk !== void 0 && _global$Clerk.loaded || (_global$Clerk2 = global.Clerk) !== null && _global$Clerk2 !== void 0 && _global$Clerk2.isReady())) {
                  _context7.next = 27;
                  break;
                }
                return _context7.abrupt("return", this.hydrateClerkJS(global.Clerk));
              case 27:
                return _context7.abrupt("return");
              case 30:
                _context7.prev = 30;
                _context7.t0 = _context7["catch"](3);
                error = _context7.t0;
                if (!(process.env.NODE_ENV === "production")) {
                  _context7.next = 37;
                  break;
                }
                console.error(error.stack || error.message || error);
                _context7.next = 38;
                break;
              case 37:
                throw _context7.t0;
              case 38:
                return _context7.abrupt("return");
              case 39:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[3, 30]]);
      }));
      function loadClerkJS() {
        return _loadClerkJS.apply(this, arguments);
      }
      return loadClerkJS;
    }()
  }, {
    key: "version",
    get: function get() {
      var _this$clerkjs17;
      return (_this$clerkjs17 = this.clerkjs) === null || _this$clerkjs17 === void 0 ? void 0 : _this$clerkjs17.version;
    }
  }, {
    key: "client",
    get: function get() {
      if (this.clerkjs) {
        return this.clerkjs.client;
      } else {
        return void 0;
      }
    }
  }, {
    key: "session",
    get: function get() {
      if (this.clerkjs) {
        return this.clerkjs.session;
      } else {
        return void 0;
      }
    }
  }, {
    key: "user",
    get: function get() {
      if (this.clerkjs) {
        return this.clerkjs.user;
      } else {
        return void 0;
      }
    }
  }, {
    key: "organization",
    get: function get() {
      if (this.clerkjs) {
        return this.clerkjs.organization;
      } else {
        return void 0;
      }
    }
  }, {
    key: "__unstable__environment",
    get: function get() {
      if (this.clerkjs) {
        return this.clerkjs.__unstable__environment;
      } else {
        return void 0;
      }
    }
  }, {
    key: "__unstable__setEnvironment",
    value: function __unstable__setEnvironment() {
      if (this.clerkjs && "__unstable__setEnvironment" in this.clerkjs) {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        this.clerkjs.__unstable__setEnvironment(args);
      } else {
        return void 0;
      }
    }
  }], [{
    key: "getOrCreateInstance",
    value: function getOrCreateInstance(options) {
      if (!(0, import_shared.inClientSide)() || !__privateGet(this, _instance)) {
        __privateSet(this, _instance, new _IsomorphicClerk(options));
      }
      return __privateGet(this, _instance);
    }
  }]);
  return _IsomorphicClerk;
}();
var IsomorphicClerk = _IsomorphicClerk;
_loaded = new WeakMap();
_domain = new WeakMap();
_proxyUrl = new WeakMap();
_instance = new WeakMap();
__privateAdd(IsomorphicClerk, _instance, void 0);